import { FailureDetail } from '@forgerock/javascript-sdk';

export interface RealFailureDetail extends FailureDetail {
  errorCode: string;
}

const messageByKey: Record<string, string> = {
  suspendedUuidExpired: 'Ce lien n’est plus actif. Il a déjà été utilisé ou est expiré.',
  default: 'Nous sommes désolés, une erreur technique est survenu. Merci de réessayer ultérieurement.',
};

const messagesByHttpCode: Record<number, Record<string, string>> = {
  401: {
    110: '<div>Suite à une trop longue inactivité, merci de <a href="." style="text-decoration: underline">rafraîchir la page</a>.</div>',
    OTPRetryLimitExceededError: 'Connexion refusée, veuillez réessayer.',
    'Captcha failure': "Le captcha n'a pas été validé.",
    default: `Vos données d'identification semblent erronées. Merci de réessayer.`,
  },
  500: {
    default: 'Nous sommes désolés, une erreur technique est survenu. Merci de réessayer ultérieurement.',
  },
};

export const getErrorMessageByCode = (httpErrorCode: number, forgerockErrorCode = 'default'): string => {
  const messageByHttpCode = messagesByHttpCode[httpErrorCode] || messagesByHttpCode[500];
  return messageByHttpCode[forgerockErrorCode] || messageByHttpCode.default;
};

export const getErrorMessageByKey = (key = 'default'): string => messageByKey[key] ?? messageByKey['default'];
